export default "__VITE_ASSET__4IL0lCUT__"